// Dynamic styles based on theme - to be used with useThemedStyles.
export const createDriverMyDayViewStyles = (theme) => ({
	container: {
		backgroundColor: theme.mainBg4,
		flex: 1,
	},
	content: {
		padding: 10,
		paddingBottom: 30,
	},
	runChipsRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginBottom: 10,
	},
	runChip: {
		backgroundColor: theme.mainBg1,
		borderRadius: 16,
		paddingVertical: 6,
		paddingHorizontal: 12,
		marginRight: 6,
		marginBottom: 6,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	runChipActive: {
		backgroundColor: theme.mainBg3,
	},
	runChipText: {
		fontSize: 13,
		color: theme.text2,
	},
	runChipTextActive: {
		color: theme.text1,
		fontWeight: '600',
	},
	card: {
		backgroundColor: theme.mainBg1,
		borderRadius: 12,
		padding: 12,
		marginBottom: 10,
		borderWidth: 1,
		borderColor: theme.border3,
	},
	subtleText: {
		color: theme.text2,
		marginBottom: 8,
	},
});
